export const isMobileSafari = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  // https://stackoverflow.com/a/29696509
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);

  // If iOS Chrome needs to be separated, use `!ua.match(/CriOS/i)` as
  // an extra condition.
  return iOS && webkit;
};

export const getUserAgent = () =>
  typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent || '' : '';

export const isIOSUserAgent = (userAgent = getUserAgent()) =>
  /iPad|iPhone|iPod/i.test(userAgent) ||
  (/Macintosh/i.test(userAgent) &&
    typeof window !== 'undefined' &&
    window.navigator?.maxTouchPoints > 1);

export const isAndroidUserAgent = (userAgent = getUserAgent()) => /Android/i.test(userAgent);

export const getMobileOperatingSystem = (userAgent = getUserAgent()) => {
  if (isIOSUserAgent(userAgent)) {
    return 'ios';
  }
  if (isAndroidUserAgent(userAgent)) {
    return 'android';
  }
  return 'desktop';
};

export const isCommonInAppBrowser = (userAgent = getUserAgent()) =>
  /Line\/|Instagram|FBAN|FBAV|FB_IAB|FB4A|FB_IAB\/|MicroMessenger|TikTok|Twitter/i.test(userAgent);
